import { ReactElement, useEffect, useState } from 'react';
import { useOpenApi } from '../../../core/providers';
import { parseApiError } from '@techshift/react-core';
import { AppToaster } from '../../../core/util';
import { User } from '@techshift/callie-private-api-typescript';
import { DeleteUserForm } from '..';

export type DeleteUserProps = {
	user: User;
	hard?: boolean;
	onSuccess?: () => void;
};
export function DeleteUser(props: DeleteUserProps): ReactElement {
	const { user, hard, onSuccess } = props;

	const { openApi } = useOpenApi();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		if (error) {
			AppToaster.show({ message: error, intent: 'danger' });
		}
	}, [error]);

	const onSubmit = () => {
		setLoading(true);
		setError('');
		openApi.users
			.deleteUser(user.id, { hard })
			.then((response) => {
				AppToaster.show({ message: 'User deleted', intent: 'success' });
				onSuccess?.();
			})
			.catch((error) => {
				parseApiError({
					error,
					unknownError: () => {
						setError('Unknown error');
					},
					requestError: () => {
						setError('Unable to reach server');
					},
					responseError: ({ response }) => {
						if (response.data.message === 'USER_NOT_FOUND') {
							setError('Cannot delete user as they do not exist');
						} else {
							setError('Unknown error');
						}
					}
				});
			})
			.finally(() => setLoading(false));
	};
	return (
		<DeleteUserForm
			id={user.id}
			hard={hard}
			loading={loading}
			onSubmit={onSubmit}
		/>
	);
}
